let mainPage = document.querySelector('.cc-main-page');
mainPage.classList.add('cc-main-page-brands');

const getBrands = async () => {  
    //Now, begin the loop download
    // console.log('getBrands');
    try {
      let lastCursor = null;
      let hasNextPage = true;
      let brands = [];
      
      while (hasNextPage) {
        const data = await fetch("https://herbolario-salud-natural.myshopify.com/api/2024-07/graphql.json", {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            "X-Shopify-Storefront-Access-Token": "504d3712007967498779ec2838ca6d31",
          },
          body:  JSON.stringify({
              query: `{
                  collections(first:250 ${lastCursor != null ? ", after: \"" + lastCursor + "\"" : ""}) {
                      edges {
                          node {
                              id
                              title
                              handle
                              image{
                                  id
                                  url
                              }
                              is_brand: metafield(namespace: "custom", key: "is_brand") {
                              value
                              }
                          }
                      }
                      pageInfo {
                        endCursor
                        hasNextPage
                      }
                  }
              }` 
          }),
        });
      
        const result = await data.json();
        lastCursor = result.data.collections.pageInfo.endCursor;
        hasNextPage = result.data.collections.pageInfo.hasNextPage;
        
        // console.log(lastCursor);
        brands = [...brands, ...result.data.collections.edges];
      }
      const filteredBrands = brands.filter(brand => brand.node.is_brand && brand.node.is_brand.value === "true");
      const sortedFilteredBrands = filteredBrands.sort((a, b) => a.node.title.localeCompare(b.node.title));
      drawBrands(sortedFilteredBrands, 0);
    } catch (error) {
      alert(error.message);
    }
}

const drawBrands = (brands, page) => {
    console.log('drawBrands', page);
    const container = document.querySelector('.brand-grid');
    const brandsPerPage = Number(container.getAttribute('data-elements'));
    const totalPages = Math.ceil(brands.length / brandsPerPage);
    const start = page * brandsPerPage;
    const end = start + brandsPerPage;
    // console.log(totalPages, "inicio", start, "final", end);
    container.innerHTML = '';
    for (let i = start; i < end; i++) {
        if (brands[i]) {
            const brand = brands[i].node;
            const brandElement = document.createElement('a');
            brandElement.href = `/collections/${brand.handle}`;
            brandElement.classList.add('brand');
            brandElement.innerHTML = `
                <img src="${brand.image?.url ? brand.image.url : 'https://cdn.shopify.com/s/files/1/0639/6598/6909/files/marca_sin_imagen.png?v=1730984410'}" alt="${brand.title}" />
                <h4>${brand.title}</h4>
            `;
            container.appendChild(brandElement);
        }
    }
    drawPagination(brands, page, totalPages);
}

const drawPagination = (brands, page, totalPages) => {

    const paginationDiv = document.querySelector('.brand-pagination');
    paginationDiv.innerHTML = '';
    const previousButton = document.createElement('button');
    previousButton.innerHTML = '< Anterior';
    previousButton.addEventListener('click', () => drawBrands(brands, page - 1));
    if(page - 1 < 0 ){
      previousButton.setAttribute('disabled', 'disabled');
    }
    paginationDiv.appendChild(previousButton);
    
    const numbersPaginationDiv = document.createElement('div');
    numbersPaginationDiv.classList.add('pagination-numbers');
    const startPage = Math.max(0, page - 1);
    const endPage = Math.min(totalPages - 1, startPage + 3);
    
    
    if(startPage > 0){
      const pageButton = document.createElement('button');
      pageButton.innerHTML = 1;
      pageButton.addEventListener('click', () => drawBrands(brands, 0));
      numbersPaginationDiv.appendChild(pageButton);
    }

    if(startPage > 1){
      const pageButton = document.createElement('button');
      pageButton.innerHTML = '...';
      pageButton.setAttribute('disabled', 'disabled');
      numbersPaginationDiv.appendChild(pageButton);
    }

    for (let i = startPage; i < endPage; i++) {      
      const pageButton = document.createElement('button');
      pageButton.innerHTML = i + 1;
      console.log(i)
      pageButton.addEventListener('click', () => drawBrands(brands, i));
      if (i === page) {
        pageButton.classList.add('active');
      }
      numbersPaginationDiv.appendChild(pageButton);
    }
    
    if(endPage < totalPages -1){
      const pageButton = document.createElement('button');
      pageButton.innerHTML = '...';
      pageButton.setAttribute('disabled', 'disabled');
      numbersPaginationDiv.appendChild(pageButton);
    }
    
    const pageButtonFinal = document.createElement('button');
    pageButtonFinal.innerHTML = totalPages;
    pageButtonFinal.addEventListener('click', () => drawBrands(brands, totalPages - 1));
    if (totalPages - 1 === page) {
      pageButtonFinal.classList.add('active');
    }
    numbersPaginationDiv.appendChild(pageButtonFinal);
    paginationDiv.appendChild(numbersPaginationDiv);
    
    const nextButton = document.createElement('button');
    nextButton.innerHTML = 'Siguiente >';
    nextButton.addEventListener('click', () => drawBrands(brands, page + 1));
    if(page + 1 == totalPages){
      nextButton.setAttribute('disabled', 'disabled');
    }
    paginationDiv.appendChild(nextButton);
    

};


getBrands();